import React from 'react';
import {useTranslation} from "react-i18next";
import {LocalDocumentCategory} from "../../../models/local-documents.models";
import {StyledDocumentTypeText, StyledNoTypePill} from "./DigitizedDocumentType.styled";

interface DigitizedDocumentTypeProps {
    type: LocalDocumentCategory | null | undefined;
}

const VALID_TYPES = ['NOTYPE', 'MEDICAL_HISTORY', 'TEST_RESULTS', 'REFERRAL', 'STATEMENT', 'OTHER'];

const DigitizedDocumentType = ({type}: DigitizedDocumentTypeProps) => {
    const { t } = useTranslation();

    if (!type || type === 'NOTYPE') {
        return <StyledNoTypePill>{t('documentsDigitization.documentType.NOTYPE')}</StyledNoTypePill>;
    }

    if (!VALID_TYPES.includes(type as LocalDocumentCategory)) {
        return <StyledDocumentTypeText $type={type}>{t('documentsDigitization.documentType.UNRECOGNIZED')}</StyledDocumentTypeText>;
    }


    return (
        <StyledDocumentTypeText $type={type}>
            {t(`documentsDigitization.documentType.${type}`)}
        </StyledDocumentTypeText>
    );
};

export default DigitizedDocumentType;